export enum CustomerEventType {
  Comment = "Comment",
  Reminder = "Reminder",
  MetInPerson = "MetInPerson"
}
